import { messageConfirm } from 'reusable/mui/modals/message-confirm'
import { ClientSource, clientSourceName } from './clientSource'

/** Asks before one connected integration takes over as the client source from another. */
export const confirmClientSourceSwitch = (params: { from: ClientSource; to: ClientSource }): Promise<boolean> =>
   messageConfirm(
      `Clients from ${clientSourceName(params.from)} will remain in the client list but no longer be kept in sync. You can switch back any time.`,
      `Switch client source to ${clientSourceName(params.to)}?`,
      { confirmButtonTitle: 'Yes, switch source' }
   )
